import React, { useState } from 'react'
import { RadioGroup, FormControlLabel, Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { Controller } from 'react-hook-form'
import { Control } from 'react-hook-form/dist/types/form'
import { Option } from '~/utils/selectOptions'
import { RadioButton } from '../RadioButton'
import clsx from 'clsx'
import { mutualTheme } from '~/utils/theme'

export type HfRadioGroupProps<TFormValues> = {
  name: string,
  row?: boolean,
  label?: string,
  options: Option[],
  className?: string,
  defaultValue?: string,
  outsideLabel?: boolean,
  containerClassName?: string,
  control: Control<TFormValues>,
  error?: any
}

const useStyles = makeStyles({
  label: {
    marginBottom: mutualTheme.spacing(0.5),
    color: mutualTheme.palette.textGray1.main
  },
  container: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  subTitle: {
    marginTop: mutualTheme.spacing(1)
  },
  inputLabel: {
    marginLeft: 0
  },
  responsiveGroup: {
    [mutualTheme.breakpoints.down('md')]: {
      marginLeft: '10px',
      marginRight: '0px'
    }
  }
})

export function HfRadioGroup<TFormValues> (props: React.PropsWithChildren<HfRadioGroupProps<TFormValues>>) {
  const { control, name, className, options, row, containerClassName, outsideLabel, label, defaultValue } = props
  const [selected, setSelected] = useState(defaultValue || null)
  const classes = useStyles()

  const handleChange = (ev: any, onChange: any) => {
    setSelected(ev.target.value)
    onChange(ev)
  }

  return (
    <Box className={clsx([classes.container, containerClassName])}>
      {outsideLabel && <Typography variant='body2' className={classes.label}>{label}</Typography>}
      <Controller
        control={control as any}
        name={name}
        render={({ field: { onChange } }) => (
          <RadioGroup className={className} row={row}>
            {options.map((option, index) => {
              return (
                <FormControlLabel
                  label=''
                  className={classes.responsiveGroup}
                  key={index}
                  value={option.value}
                  classes={{ root: classes.inputLabel }}
                  onChange={(ev) => handleChange(ev, onChange)}
                  control={<RadioButton selectedOption={selected} label={option.label} />}
                />
              )
            })}
          </RadioGroup>
        )}
      />
    </Box>
  )
}
